import { useEffect, useState } from "react";
import { apigetallHomePyqs, apigetHomePyqsByCategory } from "../../services/apihomePyqs/apihomepyq";
import { Link } from "react-router-dom";
import apiurl from "../../services/apiendpoint/apiendpoint";

export default function Pyqhomepage () {

    const [pyqData, setPyqData] = useState([]);
    const [allPyqData, setAllPyqData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categories, setCategories] = useState([]);
    
    useEffect(() => {
        fetchAllPyqData();
    }, []);

    const fetchAllPyqData = () => {
        setLoading(true);
        apigetallHomePyqs({})
          .then((res) => {
            if (res?.resdata) {
                setPyqData(res.resdata);
                setAllPyqData(res.resdata);
                
                const uniqueCategories = [...new Set(res.resdata.map(item => item.Category))];
                setCategories(uniqueCategories);
            }
          })
          .catch((err) => console.error(err))
          .finally(() => setLoading(false));
    };

    const fetchPyqDataByCategory = (category) => {
        setLoading(true);
        apigetHomePyqsByCategory({ category })
          .then((res) => {
            if (res?.resdata) setPyqData(res.resdata);
          })
          .catch((err) => console.error(err))
          .finally(() => setLoading(false));
    };

    const handleCategoryChange = (e) => {
        const category = e.target.value;
        setSelectedCategory(category);
        
        if (category === "") {
            setPyqData(allPyqData);
        } else {
            fetchPyqDataByCategory(category);
        }
    };
    
    if (loading) return <div className="py-10 text-center">Loading...</div>;


    return (
        <>
         <section className="py-10 bg-gray-50">
              <div className="max-w-[75rem] mx-auto px-4">
                <div className="flex items-center justify-between mb-5">
                    <h2 className="text-2xl">Previous Year Papers</h2>
                    <select 
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        className="px-4 py-2.5 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-regal-blue focus:border-transparent"
                    >
                      <option value="">All Categories</option>
                      {categories.map((category, index) => (
                        <option key={index} value={category}>{category}</option>
                      ))}
                    </select>
                </div>
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                  {pyqData.map((item) => (
                    <div key={item._id} 
                      className="overflow-hidden transition-shadow duration-300 bg-white shadow-[0px_0px_29px_0px_rgba(0,_0,_0,_0.1)] rounded-xl hover:shadow-[0px_0px_40px_0px_rgba(0,_0,_0,_0.15)]"
                    >
                      <div className="p-4">
                        <div className="mb-4 overflow-hidden rounded-lg">
                            <img src={`${apiurl()}/${item.Cover_image}`} alt="" className="object-cover w-full h-48 transition-transform duration-300 ease-in-out rounded-lg hover:scale-110" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-800">
                          {item.Title || ""}
                        </h3>
        
                        <Link to={`/pyq-details/${(item.slug)}`}>
                            <button className="mt-4 w-full bg-regal-blue hover:bg-gradient-to-l hover:from-regal-yellow hover:to-regal-blue text-white font-medium py-2.5
                             rounded-lg transition-all duration-200 transform">
                                View Details
                            </button>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
        </>
    )
}